<template>
  <div>
    <template v-if="isShippingReturnsFinalOfferCopy">
      You have 90 days to return most {{ brandName }} purchases. The Final Offer items are Final Sale and cannot be returned.
    </template>
    For complete details, see our
    <a
      :href="shippingUrl"
      target="_blank"
      rel="noopener noreferrer"
      data-testid="shipping-link"
    > Shipping</a> and
    <a
      :href="returnsUrl"
      target="_blank"
      rel="noopener noreferrer"
      data-testid="returns-link"
    > Returns</a> policies.
  </div>
</template>

<script setup>
import { customerServiceUrls, brandName } from 'config';
import { useBrand } from '@composables/useBrand';
import { useFeatureEligibility, useProductFlags } from '@modules/featureControl';

const { isMcom } = useBrand();
const { isInternationalMode, isShippingReturnsFinalOfferCopy } = useFeatureEligibility();
const { isBigTicketItemFlag } = useProductFlags();
const { shipping, returns, bigTicketShipping } = customerServiceUrls;

const bigTicketUrlBasedOnMode = isInternationalMode ? bigTicketShipping?.international : bigTicketShipping?.domestic;
const shippingUrlBasedOnMode = isInternationalMode ? shipping.international : shipping.domestic;
const returnsUrlBasedOnMode = isInternationalMode ? returns.international : returns.domestic;

const shippingUrl = (isMcom && isBigTicketItemFlag) ? bigTicketUrlBasedOnMode : shippingUrlBasedOnMode;
const returnsUrl = (isMcom && isBigTicketItemFlag) ? bigTicketUrlBasedOnMode : returnsUrlBasedOnMode;
</script>
